/**
 * CoinGecko coin profile URL when we have a resolved CoinGecko ID
 * (e.g. from market-cap rank enrichment).
 */
export function getCoinGeckoProfileUrl(coinGeckoId: string | null | undefined): string | null {
	const id = coinGeckoId?.trim();
	if (!id) return null;
	return `https://www.coingecko.com/en/coins/${encodeURIComponent(id)}`;
}
